<form [formGroup]="form" class="h-100 m-0">
  <div class="card card-custom">
    <div class="card-header">
      <div class="d-flex align-items-center">
        <div
          *ngIf="data.document?.id"
          style="width: 100px !important"
          class="d-flex align-items-center mr-4"
        >
          <span
            #toggleType
            [hidden]="showTypeSelect"
            style="height: 36px !important"
            [ngClass]="getTypeClass()"
            [class.clickable]="!data.viewMode"
            class="label label-xl label-inline w-100 py-0"
          >
            {{ form.get('type').value?.replace('_', ' ') }}
          </span>
          <mat-form-field [hidden]="!showTypeSelect" appearance="standard" class="w-100">
            <mat-label>{{ 'DOCS_MODULE.DOCUMENT.TYPE' | translate }}</mat-label>
            <mat-select
              #typeSelect
              formControlName="type"
              required
              (selectionChange)="handleDocTypeChange($event.value)"
            >
              <mat-option *ngFor="let type of docTypes" [value]="type">{{
                type.replace('_', ' ')
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <ng-container *ngIf="data.document?.id">
          <mat-form-field
            [hidden]="form.get('type').value !== DocType.VIDEO_LINK || !showNameInput"
            appearance="standard"
            style="width: 250px !important"
          >
            <mat-label>{{ 'DOCS_MODULE.DOCUMENT.NAME' | translate }}</mat-label>
            <input #nameInput matInput type="text" formControlName="name" required />
          </mat-form-field>
        </ng-container>
        <div [hidden]="showNameInput" class="card-title">
          <h3
            #toggleName
            style="height: 36px !important; min-width: 250px !important"
            class="card-label d-flex align-items-center"
          >
            {{ getTitle() | translate }}
          </h3>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <ng-container *ngIf="data.document?.id">
          <div style="width: 250px !important" class="d-flex align-items-center mr-4">
            <span
              #toggleCategory
              [hidden]="showCategoryAutocomplete"
              style="
                height: 36px !important;
                color: inherit !important;
                border-width: 2px !important;
              "
              [ngClass]="
                categoryAutocomplete.value ? 'label-outline-secondary' : 'label-outline-danger'
              "
              [class.clickable]="!data.viewMode"
              class="label label-xl label-inline w-100 py-0"
            >
              {{ categoryAutocomplete.value?.name || 'Select Category' }}
              <span *ngIf="!categoryAutocomplete.value" class="text-danger ml-1">*</span>
            </span>
            <div [hidden]="!showCategoryAutocomplete" class="w-100">
              <kt-general-autocomplete
                #categoryAutocomplete
                [label]="'DOCS_MODULE.DOCUMENT.CATEGORY' | translate"
                [appearance]="'standard'"
                [dataPath]="'data'"
                [control]="categoryAutocomplete"
                [loadItemsFunction]="getCategoryAutocomplete"
                [optionFormatter]="formatCategoryOption"
                [valueFormatter]="formatCategoryOption"
                [change]="handleCategoryChange.bind(this)"
                [required]="true"
                [showError]="false"
                [readOnly]="data.viewMode"
              ></kt-general-autocomplete>
            </div>
          </div>
          <div>
            <button
              mat-raised-button
              [matTooltip]="'GLOBAL.VISIBLE_EXPIRY' | translate"
              data-toggle="dropdown"
              class="btn btn-icon btn-light dropdown-toggle symbol symbol-20 mr-2"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/calendar.svg"
                class="svg-icon svg-icon-lg symbol-label"
              ></span>
              <span
                [ngClass]="
                  form.get('visibleAfter').value || form.get('expiryAfter').value
                    ? 'bg-danger'
                    : 'bg-secondary'
                "
                class="symbol-badge"
              ></span>
            </button>
            <div
              class="dropdown-menu dropdown-menu-xl dropdown-menu-right dropdown-menu-anim-up p-5"
              (click)="$event.stopPropagation()"
            >
              <mat-form-field appearance="fill" class="w-100 mb-4">
                <mat-label>{{ 'DOCS_MODULE.DOCUMENT.VISIBLE_AFTER' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="visibleAfter"
                  [matDatepicker]="$any(visibleAfterDatePicker)"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="visibleAfterDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #visibleAfterDatePicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-100">
                <mat-label>{{ 'DOCS_MODULE.DOCUMENT.EXPIRY_AFTER' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="expiryAfter"
                  [min]="form.get('visibleAfter').value"
                  [matDatepicker]="expiryAfterDatePicker"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="expiryAfterDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #expiryAfterDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <ng-container *ngIf="form.get('type').value !== DocType.VIDEO_LINK">
            <button
              mat-raised-button
              [matTooltip]="'GLOBAL.SHARE' | translate"
              class="btn btn-icon btn-light mr-2"
              (click)="shareDocument($event)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/reply.svg"
                class="svg-icon svg-icon-lg"
              ></span>
            </button>
            <div>
              <button
                mat-raised-button
                [matTooltip]="'GLOBAL.DOWNLOAD' | translate"
                data-toggle="dropdown"
                class="btn btn-icon btn-light dropdown-toggle mr-2"
              >
                <span
                  inlineSVG="assets/media/svg/icons/Files/Download.svg"
                  class="svg-icon svg-icon-lg"
                ></span>
              </button>
              <div
                class="dropdown-menu dropdown-menu-xl dropdown-menu-right dropdown-menu-anim-up p-5"
                (click)="$event.stopPropagation()"
              >
                <mat-form-field appearance="fill" class="w-100 mb-4">
                  <mat-label>{{ 'GLOBAL.DOWNLOAD_REASON' | translate }}</mat-label>
                  <textarea matInput required [formControl]="downloadReasonCtrl"></textarea>
                  <mat-error *ngIf="isInvalid(downloadReasonCtrl)">{{
                    getErrorMessage('GLOBAL.DOWNLOAD_REASON' | translate)
                  }}</mat-error>
                </mat-form-field>
                <div class="d-flex justify-content-end">
                  <button
                    mat-raised-button
                    style="width: 100px !important"
                    class="btn btn-sm btn-primary"
                    (click)="downloadFile($event)"
                  >
                    {{ 'GLOBAL.DOWNLOAD' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <button
          mat-raised-button
          [matTooltip]="'GLOBAL.CLOSE' | translate"
          [disabled]="submitted"
          class="btn btn-icon btn-light"
          (click)="closeDialog($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
            class="svg-icon svg-icon-lg"
          ></span>
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row h-100">
        <div
          style="border-right: 1px solid #ebedf3 !important; padding-right: 2.25rem !important"
          class="col-8 h-100 py-10"
        >
          <div
            *ngIf="data.document?.id"
            class="position-relative h-100"
            (mouseenter)="showChangeBtn = true"
            (mouseleave)="showChangeBtn = false"
          >
            <div
              *ngIf="!data.viewMode && showChangeBtn && !showSrcLayout"
              matTooltip="Change Source"
              class="btn-round"
            >
              <button class="btn btn-hover-warning" (click)="toggleShowLayout($event)">
                <span
                  inlineSVG="assets/media/svg/icons/General/change-file.svg"
                  class="svg-icon svg-icon-md m-0"
                ></span>
              </button>
            </div>
            <div *ngIf="showSrcLayout" class="layout src-layout d-flex flex-center">
              <div
                style="height: fit-content !important; width: 500px !important"
                class="border rounded bg-white p-5"
              >
                <mat-form-field
                  *ngIf="form.get('type').value === DocType.VIDEO_LINK"
                  appearance="fill"
                  class="w-100 mb-4"
                >
                  <mat-label>{{ 'DOCS_MODULE.DOCUMENT.URL' | translate }}</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="url"
                    required
                    (change)="showMsgLayout = true"
                  />
                  <mat-error *ngIf="isInvalid('url')">{{
                    getErrorMessage('DOCS_MODULE.DOCUMENT.URL' | translate)
                  }}</mat-error>
                </mat-form-field>
                <div
                  *ngIf="form.get('type').value !== DocType.VIDEO_LINK"
                  class="file-input mb-4"
                  (click)="clickFileInput($event, fileInput)"
                >
                  <div>
                    <mat-form-field appearance="fill">
                      <mat-label>{{ 'DOCS_MODULE.DOCUMENT.FILE' | translate }}</mat-label>
                      <input matInput required readonly type="text" formControlName="name" />
                      <input
                        #fileInput
                        required
                        hidden
                        type="file"
                        [accept]="form.get('type').value | docExt"
                        (change)="changeFile($event)"
                      />
                      <mat-error *ngIf="isInvalid('file')">{{
                        getErrorMessage('DOCS_MODULE.DOCUMENT.FILE' | translate)
                      }}</mat-error>
                    </mat-form-field>
                  </div>
                  <button
                    matTooltip="{{ 'TABLE.ATTACH' | translate }} File"
                    class="btn btn-icon btn-light-primary btn-hover-primary"
                  >
                    <span
                      inlineSVG="assets/media/svg/icons/General/attachment.svg"
                      class="svg-icon svg-icon-lg svg-icon-primary"
                    ></span>
                  </button>
                </div>
                <div class="d-flex justify-content-end">
                  <button
                    mat-raised-button
                    style="width: 100px !important"
                    class="btn btn-sm btn-light"
                    (click)="undoSrcChange($event)"
                  >
                    {{ 'GLOBAL.UNDO' | translate }}
                  </button>
                  <button
                    mat-raised-button
                    style="width: 100px !important"
                    class="btn btn-sm btn-primary ml-4"
                    (click)="toggleShowLayout($event)"
                  >
                    {{ 'GLOBAL.KEEP' | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="showMsgLayout" class="layout msg-layout d-flex flex-center">
              <div
                style="font-size: 2rem !important"
                class="font-weight-bolder text-white text-center w-75"
              >
                To view the document's new source content, please SAVE your changes.
              </div>
            </div>
            <kt-docs-viewer
              [type]="data.document?.type"
              [url]="data.document?.url"
            ></kt-docs-viewer>
          </div>
          <div *ngIf="!data.document?.id">
            <div class="w-100 mb-4">
              <kt-general-autocomplete
                #categoryAutocomplete
                [label]="'DOCS_MODULE.DOCUMENT.CATEGORY' | translate"
                [dataPath]="'data'"
                [control]="categoryAutocomplete"
                [loadItemsFunction]="getCategoryAutocomplete"
                [optionFormatter]="formatCategoryOption"
                [valueFormatter]="formatCategoryOption"
                [change]="handleCategoryChange.bind(this)"
                [required]="true"
                [readOnly]="data.viewMode"
              ></kt-general-autocomplete>
            </div>
            <mat-form-field appearance="fill" class="w-100 mb-4">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.REFERENCE_ID' | translate }}</mat-label>
              <input matInput type="text" formControlName="referenceId" />
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-100 mb-4">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.TYPE' | translate }}</mat-label>
              <mat-select
                formControlName="type"
                required
                (selectionChange)="handleDocTypeChange($event.value)"
              >
                <mat-option *ngFor="let type of docTypes" [value]="type">{{
                  type.replace('_', ' ')
                }}</mat-option>
              </mat-select>
              <mat-error *ngIf="isInvalid('type')">{{
                getErrorMessage('DOCS_MODULE.DOCUMENT.TYPE' | translate)
              }}</mat-error>
            </mat-form-field>
            <ng-container *ngIf="form.get('type').value === DocType.VIDEO_LINK">
              <mat-form-field appearance="fill" class="w-100 mb-4">
                <mat-label>{{ 'DOCS_MODULE.DOCUMENT.NAME' | translate }}</mat-label>
                <input matInput type="text" formControlName="name" required />
                <mat-error *ngIf="isInvalid('name')">{{
                  getErrorMessage('DOCS_MODULE.DOCUMENT.NAME' | translate)
                }}</mat-error>
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-100 mb-4">
                <mat-label>{{ 'DOCS_MODULE.DOCUMENT.URL' | translate }}</mat-label>
                <input matInput type="text" formControlName="url" required />
                <mat-error *ngIf="isInvalid('url')">{{
                  getErrorMessage('DOCS_MODULE.DOCUMENT.URL' | translate)
                }}</mat-error>
              </mat-form-field>
            </ng-container>
            <div
              *ngIf="form.get('type').value !== DocType.VIDEO_LINK"
              class="file-input mb-4"
              (click)="clickFileInput($event, fileInput)"
            >
              <div>
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>{{ 'DOCS_MODULE.DOCUMENT.FILE' | translate }}</mat-label>
                  <input matInput required readonly type="text" formControlName="name" />
                  <input
                    #fileInput
                    required
                    hidden
                    type="file"
                    [accept]="form.get('type').value | docExt"
                    (change)="changeFile($event)"
                  />
                  <mat-error *ngIf="isInvalid('file')">{{
                    getErrorMessage('DOCS_MODULE.DOCUMENT.FILE' | translate)
                  }}</mat-error>
                </mat-form-field>
              </div>
              <button
                matTooltip="{{ 'TABLE.ATTACH' | translate }} File"
                class="btn btn-icon btn-light-primary btn-hover-primary"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/attachment.svg"
                  class="svg-icon svg-icon-lg svg-icon-primary"
                ></span>
              </button>
            </div>
            <div class="w-100 mb-4">
              <div class="row">
                <mat-form-field appearance="fill" class="col-6">
                  <mat-label>{{ 'DOCS_MODULE.DOCUMENT.VISIBLE_AFTER' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="visibleAfter"
                    [matDatepicker]="$any(visibleAfterDatePicker)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="visibleAfterDatePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #visibleAfterDatePicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="fill" class="col-6">
                  <mat-label>{{ 'DOCS_MODULE.DOCUMENT.EXPIRY_AFTER' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="expiryAfter"
                    [min]="form.get('visibleAfter').value"
                    [matDatepicker]="expiryAfterDatePicker"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="expiryAfterDatePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #expiryAfterDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div
          style="padding-left: 2.25rem !important"
          class="col-4 scroll h-100 pt-10 pb-5"
          [perfectScrollbar]="{ wheelPropagation: false }"
        >
          <div style="border-bottom: 1px solid #ebedf3 !important" class="pb-10">
            <div class="mat-form-field mat-form-field-appearance-fill w-100 mb-4">
              <div class="mat-form-field-wrapper">
                <div class="row">
                  <div class="col-2">
                    <div
                      [matTooltip]="
                        !!data.document?.entity_id
                          ? 'Entities'
                          : form.get('category').value
                          ? 'Assign Entities'
                          : 'Select document category first!'
                      "
                      [matTooltipPosition]="'above'"
                    >
                      <button
                        [disabled]="
                          data.viewMode || !!data.document?.entity_id || !form.get('category').value
                        "
                        [class.btn-error]="isInvalid('entities')"
                        class="btn btn-round-dashed btn-light"
                        (click)="assignEntities($event)"
                      >
                        <span
                          inlineSVG="assets/media/svg/icons/Communication/Add-user.svg"
                          class="svg-icon svg-icon-md m-0"
                        ></span>
                      </button>
                    </div>
                  </div>
                  <div class="col-10">
                    <div [innerHtml]="entitiesString$ | async | safe : 'html'"></div>
                  </div>
                </div>
                <div *ngIf="isInvalid('entities')" class="mat-form-field-subscript-wrapper">
                  <mat-error>{{
                    getErrorMessage('DOCS_MODULE.DOCUMENT.ENTITIES' | translate)
                  }}</mat-error>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-2">
                <div
                  [matTooltip]="
                    form.get('type').value === DocType.INVOICE
                      ? 'No relations to be selected with invoice document'
                      : form.get('primaryReviewer').value
                      ? 'No relations to be selected with primary reviewer'
                      : !form.get('entities').value?.length
                      ? 'Assign entities first!'
                      : 'Select Relations'
                  "
                  class="d-inline-block"
                >
                  <button
                    [disabled]="
                      data.viewMode ||
                      form.get('type').value === DocType.INVOICE ||
                      form.get('primaryReviewer').value ||
                      !form.get('entities').value?.length
                    "
                    class="btn btn-round-dashed btn-light"
                    (click)="selectRelations($event)"
                  >
                    <span
                      inlineSVG="assets/media/svg/icons/Files/Share.svg"
                      class="svg-icon svg-icon-md m-0"
                    ></span>
                  </button>
                </div>
              </div>
              <div class="col-10">
                <div [innerHtml]="relationsString$ | async | safe : 'html'"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-2"></div>
              <div class="col-10">
                <div class="d-flex align-items-center">
                  <mat-label style="width: 170px !important" class="d-inline-block">
                    {{ 'DOCS_MODULE.DOCUMENT.PHI' | translate }}
                    <small class="text-muted"
                      >({{
                        (form.get('phi').value ? 'GLOBAL.ACTIVE' : 'GLOBAL.INACTIVE') | translate
                      }})</small
                    >
                  </mat-label>
                  <mat-slide-toggle
                    formControlName="phi"
                    [disabled]="
                      form.get('type').value === DocType.INVOICE ||
                      !form.get('category').value?.override_phi
                    "
                  ></mat-slide-toggle>
                </div>
                <div class="d-flex align-items-center">
                  <mat-label style="width: 170px !important" class="d-inline-block">
                    {{ 'DOCS_MODULE.DOCUMENT.PATIENT_ONLY' | translate }}
                    <small class="text-muted"
                      >({{
                        (form.get('patientOnly').value ? 'GLOBAL.ACTIVE' : 'GLOBAL.INACTIVE')
                          | translate
                      }})</small
                    >
                  </mat-label>
                  <mat-slide-toggle
                    formControlName="patientOnly"
                    [disabled]="
                      form.get('type').value === DocType.INVOICE ||
                      !form.get('category').value?.override_patient_only
                    "
                  ></mat-slide-toggle>
                </div>
                <div class="d-flex align-items-center">
                  <mat-label style="width: 170px !important" class="d-inline-block">
                    {{ 'DOCS_MODULE.DOCUMENT.MOBILE_VISIBLE' | translate }}
                    <small class="text-muted"
                      >({{
                        (form.get('mobileVisible').value ? 'GLOBAL.ACTIVE' : 'GLOBAL.INACTIVE')
                          | translate
                      }})</small
                    >
                  </mat-label>
                  <mat-slide-toggle
                    formControlName="mobileVisible"
                    [disabled]="!form.get('category').value?.override_mobile_visible"
                  ></mat-slide-toggle>
                </div>
              </div>
            </div>
          </div>
          <div style="border-bottom: 1px solid #ebedf3 !important" class="pt-10 pb-5">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.DESCRIPTION' | translate }}</mat-label>
              <textarea matInput formControlName="description" rows="8" required></textarea>
              <mat-error *ngIf="isInvalid('description')">{{
                getErrorMessage('DOCS_MODULE.DOCUMENT.DESCRIPTION' | translate)
              }}</mat-error>
            </mat-form-field>
          </div>
          <div class="pt-10">
            <div class="mb-8">
              <div class="d-flex align-items-center">
                <mat-label style="width: 170px !important" class="d-inline-block">
                  {{ 'DOCS_MODULE.DOCUMENT.REVIEW' | translate }}
                  <small class="text-muted"
                    >({{
                      (form.get('requiresReview').value ? 'GLOBAL.REQUIRED' : 'GLOBAL.NOT_REQUIRED')
                        | translate
                    }})</small
                  >
                </mat-label>
                <mat-slide-toggle
                  formControlName="requiresReview"
                  (change)="handleRequiresReviewToggle($event.checked)"
                ></mat-slide-toggle>
              </div>
              <div class="d-flex align-items-center">
                <mat-label style="width: 170px !important" class="d-inline-block">
                  {{ 'DOCS_MODULE.DOCUMENT.REVIEWER' | translate }}
                  <small class="text-muted"
                    >({{
                      (form.get('primaryReviewer').value ? 'GLOBAL.PRIMARY' : 'GLOBAL.NOT_PRIMARY')
                        | translate
                    }})</small
                  >
                </mat-label>
                <mat-slide-toggle
                  formControlName="primaryReviewer"
                  [disabled]="!form.get('requiresReview').value"
                  (change)="handleReviewerToggle($event.checked)"
                ></mat-slide-toggle>
              </div>
            </div>
            <mat-form-field
              [hidden]="!form.get('requiresReview').value"
              appearance="fill"
              class="w-100 mb-4"
            >
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.REVIEW_MODE' | translate }}</mat-label>
              <mat-select
                formControlName="reviewMode"
                [required]="form.get('requiresReview').value"
              >
                <mat-option [value]="ReviewMode.ACKNOWLEDGE">Acknowledge</mat-option>
                <mat-option [value]="ReviewMode.ACCEPT_REJECT">Accept / Reject</mat-option>
                <mat-option
                  *ngIf="form.get('category').value?.form?.id"
                  [value]="ReviewMode.FILL_FORM"
                  >Fill Form</mat-option
                >
              </mat-select>
              <mat-error *ngIf="isInvalid('reviewMode')">{{
                getErrorMessage('DOCS_MODULE.DOCUMENT.REVIEW_MODE' | translate)
              }}</mat-error>
            </mat-form-field>
            <div class="w-100 mb-4">
              <kt-general-autocomplete
                #contactAutocomplete
                [label]="'DOCS_MODULE.DOCUMENT.CONTACT_REVIEWERS' | translate"
                [chipList]="true"
                [dataPath]="'data'"
                [control]="contactAutocomplete"
                [objects]="contactAutocomplete.value"
                [loadItemsFunction]="getContactAutocomplete"
                [optionFormatter]="formatContactOption"
                [valueFormatter]="formatContactOption"
                [formatNewObjectFn]="formatNewContact"
                [readOnly]="
                  data.viewMode ||
                  !form.get('entities').value?.length ||
                  !form.get('requiresReview').value ||
                  form.get('primaryReviewer').value
                "
              ></kt-general-autocomplete>
            </div>
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.REVIEW_BY_DATE' | translate }}</mat-label>
              <input
                matInput
                formControlName="reviewByDate"
                [min]="form.get('visibleAfter').value"
                [max]="form.get('expiryAfter').value"
                [matDatepicker]="reviewByDatePicker"
              />
              <mat-datepicker-toggle matSuffix [for]="reviewByDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #reviewByDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex align-items-center justify-content-between">
      <div>
        <div *ngIf="data.document?.id">
          <span class="font-weight-bold mr-4">Reference ID:</span
          >{{ form.get('referenceId').value }}
        </div>
      </div>
      <div>
        <button
          mat-raised-button
          cdkFocusInitial
          [disabled]="submitted || !valuesChanged"
          class="btn btn-sm btn-light"
          (click)="cancel($event)"
        >
          {{ 'GLOBAL.CANCEL' | translate }}
        </button>
        <button
          *ngIf="!data.viewMode"
          mat-raised-button
          [disabled]="submitted || !valuesChanged"
          class="btn btn-sm btn-primary ml-4"
          (click)="submit($event)"
        >
          <ng-container *ngIf="!submitted"> {{ 'GLOBAL.SAVE' | translate }} </ng-container>
          <ng-container *ngIf="submitted">
            <span class="spinner-border spinner-border-sm"></span>
            {{ 'GLOBAL.SAVING' | translate }}
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</form>
